import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {CalendarService} from "../calendar.service";
import {CalendarDialogRepeatComponent} from "../dialog-repeat/dialog-repeat.component";
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService, HttpClientService} from 'inet-core';
import {CalendarDialogDelete} from "../dialog-delete/dialog-delete.component";
import {AttachmentListComponent} from "../attachment-list/attachment-list.component";
import {CalEvent, CalRepeat} from "../utils/model/CalEvent";
import {CalAttendee} from "../utils/model/CalAttendee";
import * as moment_ from 'moment';
import {vnToLatin} from "../utils/common/Accent";
import {CalAttendeeType} from "../utils/model/CalAttendeeType";
import {Observable} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {TypeaheadMatch} from "ngx-bootstrap/typeahead";
import {CalendarUtils} from "../CalendarUtils";

const moment = moment_;
declare let iNet: any;

@Component({
  selector: 'app-calendar-form',
  templateUrl: './calendar-form.component.html',
  styleUrls: [
    './calendar-form.component.scss'
  ]
})
export class CalendarFormComponent implements AfterViewInit, OnInit, OnChanges, OnDestroy {
  @ViewChild(CalendarDialogRepeatComponent) repeatModal!: CalendarDialogRepeatComponent;
  @ViewChild('dialogRemove') viewDeleteModal!: CalendarDialogDelete;
  @ViewChild('titleInput') titleInput!: ElementRef;
  @ViewChild('attendeeInput') attendeeInput!: ElementRef;
  @ViewChild(AttachmentListComponent) fileList!: AttachmentListComponent;
  event: CalEvent = {};
  repeatText?: string;
  eventNotFound: boolean = false;
  timeError: boolean = false;
  attendeeModal: any;
  formData = {
    title: '',
    date: '',
    startTime: '',
    toTime: '',
    location: '',
    summary: '',
    state: '',
    notes: '',
    repeat: false,
    _allday: ''
  };
  subscription: any;

  @Output() onBack = new EventEmitter<boolean>();
  @Output() onReload = new EventEmitter<boolean>();
  @Output() onView = new EventEmitter<boolean>();
  @Output() onSave = new EventEmitter<boolean>();
  @Output() onRemove = new EventEmitter<boolean>();
  @Input() dataEvent: any;
  @Input() id: string = '';
  attendees: CalAttendee[] = [];
  _attendees: CalAttendee[] = [];

  constructor(private route: ActivatedRoute,
              private calendarService: CalendarService,
              private notify: NotificationService,
              private router: Router,
              private http: HttpClientService) {
    this.subscription = this.calendarService.eventChange$.subscribe(
      value => {
        this.id = value
        this.calendarService.loadEvent({
          element: this.id
        }, (event: any) => {
          if (!event) {
            this.eventNotFound = true;
            return;
          }
          this.event = event;
          this.onRemove.emit(true);
          this.onSave.emit(true);
          this.attendees = event.attendees;
          if (event.members) {
            this.event.myAttendee = event.members.find((item: any) => {
              return item.role !== 'CREATOR' && item.username === iNet.username;
            });
          }
          this._initForm();
        });
        setTimeout(() => {
          this.onView.emit(true);
        })
      });
    this.calendarService.loadAttendees((attendees: any) => this._attendees = attendees)
  }

  ngAfterViewInit(): void {
    this.titleInput.nativeElement.focus();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!iNet.isEmpty(changes['dataEvent'])) {
      this.id = "";
    }
    this.calendarService.ready(() => {
      // let params = this.route.snapshot.paramMap;
      if (!iNet.isEmpty(this.id)) {
        this.calendarService.loadEvent({
          element: this.id
        }, (event: any) => {
          if (!event) {
            this.eventNotFound = true;
            return;
          }
          this.event = event;
          this.onRemove.emit(true);
          this.onSave.emit(true);
          this.attendees = event.attendees;
          if (event.members) {
            this.event.myAttendee = event.members.find((item: any) => {
              return item.role !== 'CREATOR' && item.username === iNet.username;
            });
          }
          this._initForm();
        });
      } else {
        let event : any;
        try {
          event = JSON.parse(atob(this.dataEvent));
          event.start = new Date(event.start);
          event.end = new Date(event.end);
          this.attendees = [];

        } catch (e) {
          event = {};
          event.start = new Date();
          event.start.setHours(event.start.getHours() + 1, 0, 0, 0);
          event.end = new Date(event.start.getTime() + 60 * 60 * 1000);
          this.attendees = [];

        }
        this.event = event;
        this.onRemove.emit(false);
        this.onSave.emit(true);
        this._initForm();
      }
    });
    this.calendarService.loadAttendees((attendees: any[]) => this._attendees = attendees);
  }

  ngOnInit() {
    this.calendarService.ready(() => {
      // let params = this.route.snapshot.paramMap;
      if (!iNet.isEmpty(this.id)) {
        this.calendarService.loadEvent({
          element: this.id
        }, (event: any) => {
          if (!event) {
            this.eventNotFound = true;
            return;
          }
          this.event = event;
          this.onRemove.emit(true);
          this.onSave.emit(true);
          this.attendees = event.attendees;
          if (event.members) {
            this.event.myAttendee = event.members.find((item: any) => {
              return item.role !== 'CREATOR' && item.username === iNet.username;
            });
          }
          this._initForm();
        });
      } else {
        let event: any;
        try {
          event = JSON.parse(atob(this.dataEvent));
          event.start = new Date(event.start);
          event.end = new Date(event.end);
          this.attendees = [];
        } catch (e) {
          event = {};
          event.start = new Date();
          event.start.setHours(event.start.getHours() + 1, 0, 0, 0);
          event.end = new Date(event.start.getTime() + 60 * 60 * 1000);
          this.attendees = [];

        }
        this.event = event;
        this.onRemove.emit(false);
        this.onSave.emit(true);
        this._initForm();
      }
    });
    this.calendarService.loadAttendees((attendees: any) => this._attendees = attendees);
  }

  private _initForm() {
    let values: any = {
      title: this.event.subject || '',
      date: this.event.start,
      startTime: moment(this.event.start).format('HH:mm'),
      toTime: moment(this.event.end).format('HH:mm'),
      location: this.event.location || '',
      summary: this.event.summary || '',
      _allday: this.event.attribute && this.event.attribute['allday'] === 'true' || false,
      state: 'NEEDS_ACTION',
      notes: '',
      repeat: false,
    };
    if (this.event.myAttendee) {
      values.state = this.event.myAttendee.state;
      values.notes = this.event.myAttendee.notes || '';
    }
    Object.assign(this.formData, values);
    if (this.event.repeat) {
      this.setRepeatData(this.event.repeat);
    }
  }

  createEvent(callback?: Function) {
    let data = this._getFormData();
    if (!data) {
      return;
    }
    // this.http.showLoading('Đang xử lý...');
    if (data.element) {
      this.calendarService.updateEvent(data, (data: any) => {
        if (data) {
          this._onSuccess();
          this.onRemove.emit(true);
          this.onSave.emit(true);
        } else {
          this.notify.showMessage('Cập nhật lịch không thành công', 'error');
          this.onRemove.emit(false);
          this.onSave.emit(true);
        }
        if (callback) {
          callback(true)
        }
      });
      this._updateMyState();
    } else {
      this.calendarService.createEvent(data, (data: any) => {
        if (data) {
          this._onSuccess();
          this.onRemove.emit(true);
          this.onSave.emit(true);
        } else {
          this.notify.showMessage('Tạo lịch không thành công', 'error');
          this.onRemove.emit(false);
          this.onSave.emit(true);
        }
        if (callback) {
          callback(true)
        }
      });
    }
  }

  private _onSuccess() {
    // this.router.navigate(['/calendar']);
    this.goBack();
  }

  private _getFormData() {
    if (!this._validate()) {
      return;
    }
    let data = this.formData;
    let params: any = {
      subject: data.title,
      summary: data.summary,
      location: data.location,
      startTime: this.getMinutes(data._allday ? '00:00' : data.startTime),
      toTime: this.getMinutes(data._allday ? '23:59' : data.toTime),
      _allday: data._allday
    };
    let date = moment(data.date);
    params.day = date.dayOfYear();
    params.year = date.year();
    if (this.event.uuid) {
      params.element = this.event.uuid;
    }
    if (data.repeat && this.event.repeat) {
      Object.assign(params, this.event.repeat);
      if (params.wkdays) {
        params.wkdays = params.wkdays.join(',');
      }
    }
    this.fileList.files.forEach((file, index) => {
      if (!file.id) {
        params['file' + index] = file;
      }
    });
    if (params.location) {
      this.calendarService.saveLocation(params.location, () => {
      });
    }

    let arr: any[] = [];
    this.attendees.forEach(ele => {
      arr.push({
        role: 'MEMBER',
        members:  ele.username + ":" + ele.fullname,
        display: ele.fullname
      });
    });


    params.attendee = JSON.stringify(arr);
    // xCalendar.modifyDataUpdate(params, this.event);
    return params;
  }

  private _hasAttendee(attendee: CalAttendee) {
    for (let i = 0; i < this.attendees.length; i++) {
      if (this.attendees[i].username === attendee.username) {
        return true;
      }
    }
    return false;
  }

  attendeeSearch: any = new Observable(subscriber => {
    let value = this.attendeeModal.trim();
    if (!value) {
      subscriber.next([]);
      return;
    }
    value = vnToLatin(value);
    subscriber.next(this._attendees.filter((item: any) => item['_index'].indexOf(value) > -1).slice(0, 10));
  }).pipe(debounceTime(200), distinctUntilChanged());

  addAttendee(e: TypeaheadMatch) {
    let attendee = e.item;
    this.attendeeModal = '';
    if (!this._hasAttendee(attendee)) {
      attendee.type = CalAttendeeType.USER;
      this.attendees.push(attendee);
    }
  }

  locationSearch: any = new Observable(subscriber => {
    let value = this.formData.location;
    if (!value) {
      subscriber.next([]);
      return;
    }
    this.calendarService.searchLocation(value, (items: any[]) => subscriber.next(items.map(item => item.content)));
  }).pipe(debounceTime(200), distinctUntilChanged());

  private _validate(): boolean {
    if (!this.formData.title.trim() || !this.formData.date) {
      return false;
    }
    if (!this.formData._allday) {
      if (this.getMinutes(this.formData.startTime) >= this.getMinutes(this.formData.toTime)) {
        this.timeError = true;
        return false;
      }
    }
    this.timeError = false;
    return true;
  }

  setRepeatData(data: CalRepeat) {
    if (!data) {
      this._clearRepeat();
      return;
    }
    this.event.repeat = data;
    this.repeatText = CalendarUtils.getRepeatText(data);
    this.formData.repeat = true;
    if (this.formData.repeat) {
      setTimeout(() => {
        this.repeatModal.openRepeat(this.event.repeat);
      }, 50)


    }
  }

  setRepeatEvent(data: CalRepeat) {
    this.event.repeat = data;
    this.repeatText = CalendarUtils.getRepeatText(data);
    this.formData.repeat = true;
  }

  openRepeats(checked: boolean) {
    if (checked) {
      setTimeout(() => {
        this.repeatModal.openRepeat(this.event.repeat);
      }, 50);
    } else {
      this._clearRepeat();

    }
  }

  onEditRepeat(e?: any) {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.repeatModal.openRepeat(this.event.repeat);
  }

  private _clearRepeat() {
    this.repeatText = '';
    this.formData.repeat = false;
  }

  private _updateMyState() {
    if (!this.event.myAttendee) {
      return;
    }
    this.calendarService.loadEvent({
      state: this.formData.state,
      notes: this.formData.notes,
      element: this.event.uuid
    }, function () {
    });
  }

  goBack() {
    // history.back();
    this.onReload.emit(true);

    this.onBack.emit(true);
  }

  onRemoveEvent(event: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.viewDeleteModal.show();
  }

  private getMinutes(hourStr: string): number {
    let hours = hourStr.split(':');
    return Number(hours[0]) * 60 + Number(hours[1]);
  }

  resetData(event: any) {
    let __event: any = event;
    __event.start = new Date(__event.start);
    __event.end = new Date(__event.end);
    this.attendees = [];
    this.event = __event;
    this._initForm();
  }

}
